<template>
  <div class="col-md-6 project-list">
    <div class="card">
      <div class="card-body d-flex justify-content-end me-3">
        <ModalCreate @reload-list-place="$emit('reload-list-place')" />
      </div>
    </div>
  </div>
</template>
<script>
import ModalCreate from "./ModalCreate.vue";

export default {
  name: "TopMenu",
  emits: ["reload-list-place"],
  components: {
    ModalCreate,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
